import React from 'react'

function Cross(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="3.4 4.31 13.1 14.07"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M16.23 4.7l-.07-.08a.95.95 0 00-1.34-.06l-.05.06-4.82 5.22-4.83-5.22a.95.95 0 00-1.39 0l-.07.07a1 1 0 000 1.36l4.9 5.3-4.9 5.3a1 1 0 000 1.35l.07.08c.36.38.96.4 1.34.05l.05-.05 4.83-5.22 4.82 5.22a.95.95 0 001.4 0l.06-.08a1 1 0 000-1.35l-4.89-5.3 4.9-5.3a1 1 0 000-1.36z"
            />
        </svg>
    )
}

export default Cross
